export const CustomFetch = (products) => {
    return new Promise((resolve, reject) => {
        resolve(products)
    })
}